import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    * {
        padding: 0px;
        margin: 0px;
        box-sizing: border-box;
    }

    body{
        background-color: #F3F3FD;
        font-family: "Inter", sans-serif; 
    }

    html{
        scroll-behavior: smooth;
        font-family: "Inter", sans-serif;
        font-optical-sizing: auto;
    }

    input{
        border: none;
        background: none;
    }

    button{
        cursor: pointer;
    }
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: white;
    }

    &::-webkit-scrollbar-thumb {
        background: #C1C1C1;
        border-radius: 10px;
    }
`

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    overflow: hidden;
`